import { Injectable } from "@angular/core";
import { map } from 'rxjs/operators';
import { Observable } from "rxjs";

import { BackendUriUnits } from "./base/backend-uri-units";
import { BaseHttpWithBundleService } from "./base/base-service-with-bundle.service";
import { HttpServiceBundle } from "./base/http-service-bundle.service";
import { environment } from '../../../environments/environment';
import { DRResponse } from "@app/shared/models/response";
import { Widget, WidgetSettings } from '@app/shared/models/widget';

@Injectable({
    providedIn: 'root'
})
export class WidgetService extends BaseHttpWithBundleService {
 
    constructor(httpServiceBundle: HttpServiceBundle) {
        super(httpServiceBundle, true);
        this.uri += `/${BackendUriUnits.DASHBOARD}/userwidgets`;
    }

    public getWidgetList(): Observable<Widget[]> {
        return this.http.get<DRResponse<Widget[]>>(this.uri)
                        .pipe(map((res: any) => res.map(w => new Widget(w))));
    }

    public saveSettings(widgetId: string, data: WidgetSettings): Observable<boolean> {
        const uri = `${this.uri}/${widgetId}`;
        return this.http.put<DRResponse<WidgetService>>(uri, {settings: data})
                        .pipe(map((res: any) => true));
    }
}
